// 后端 api 接口对应的前缀
const envPrefixMap = {
    'prod': '',
    'local': 'd-',
    'dev': 'd-',
    'pre': 'p-',
    'test': 't-'
};
function isValidUrl(url = '') {
    return url.startsWith('//') || url.startsWith('http');
}
/**
 * 根据不同的环境，给 prod 的 url 添加不同的前缀
 * 如，在 env 为 `test` 的情况下：
 * https://ser-cloud.xinchao.com/portal -> https:// t-ser-cloud.xinchao.com/portal
 */
function getUrlByENV(prodUrl, env = 'prod') {
    if (!isValidUrl(prodUrl)) {
        throw new Error(`invalid prodUrl :${prodUrl}`);
    }
    if (env === 'prod') {
        return prodUrl;
    }
    else {
        const urlParts = prodUrl.split('//');
        if (urlParts.length < 2) {
            throw new Error(`invalid prodUrl :${prodUrl}`);
        }
        const protocol = urlParts[0];
        const path = urlParts[1];
        const prefix = envPrefixMap[env];
        if (prefix) {
            return `${protocol}//${envPrefixMap[env]}${path}`;
        }
        else {
            throw new Error(`invalid env :${env}`);
        }
    }
}
function isInXinchaoDomain(domain) {
    if (domain === '') {
        return false;
    }
    else if (/\.xinchao\.(mobi|com)/.test(domain)) {
        return true;
    }
    else if (/\.boleme\.net/.test(domain)) {
        return true;
    }
    return false;
}

export { getUrlByENV as g, isInXinchaoDomain as i };
//# sourceMappingURL=getUrlByENV-0c97c003.js.map
